import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/gallery";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
            <i className="ri-image-2-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-semibold text-foreground-950 whitespace-nowrap">
            年轻的岳母
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#subscribe"
            className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            订阅更新
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300/70 text-foreground-900 cursor-pointer"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="py-3 text-sm text-foreground-700 border-b border-background-200/60 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-3 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center cursor-pointer"
            >
              订阅更新
            </a>
          </div>
        </div>
      )}
    </header>
  );
}